import { Link } from '@inertiajs/react'

export default function BorrowerCtaBanner() {
  return (
    <div className="mt-12 rounded-2xl p-8 sm:p-12 text-center bg-gradient-to-r from-emerald-600 to-emerald-700">
      <p className="text-sm font-semibold text-emerald-200 uppercase tracking-wide">
        For Borrowers
      </p>
      <h3 className="mt-2 text-xl sm:text-2xl font-bold text-white">
        Track all your private loans in one place
      </h3>
      <p className="mt-2 text-emerald-100 max-w-lg mx-auto">
        Maturity dates, true borrowing costs, and payment history across every lender — free forever for early users.
      </p>
      <Link
        href="/my-loans"
        className="mt-6 inline-flex items-center gap-2 px-8 py-3 bg-white hover:bg-gray-50 text-emerald-700 font-semibold rounded-lg transition-colors"
      >
        Join free
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
      </Link>
    </div>
  )
}
